import { render, staticRenderFns } from "./BusinessFinishAddVault.vue?vue&type=template&id=36314444"
import script from "./BusinessFinishAddVault.vue?vue&type=script&lang=js"
export * from "./BusinessFinishAddVault.vue?vue&type=script&lang=js"
import style0 from "./BusinessFinishAddVault.vue?vue&type=style&index=0&id=36314444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports